'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REQUESTING = exports.REQUESTING = 'tq-plus-admin/fetch/status/REQUESTING';
var SUCCEEDED = exports.SUCCEEDED = 'tq-plus-admin/fetch/status/SUCCEEDED';
var UNRETRIEVED = exports.UNRETRIEVED = 'tq-plus-admin/fetch/status/UNRETRIEVED';
var FAILED = exports.FAILED = 'tq-plus-admin/fetch/status/FAILED';


//////////////////
// WEBPACK FOOTER
// ./src/constants/fetchStatusTypes.js
// module id = 151
// module chunks = 0